import React from 'react';
import { Typography, Grid, Card, Box, Paper, Divider } from '@mui/material';

function OrderSummaryInfo({ data = [], title }) {
  return (
    <>
      <Paper
        elevation={3}
        variant='outlined'
        sx={{
          padding: 2,
          marginBottom: 2,
          borderRadius: '1rem',
          width: '49%',
        }}
      >
        <Typography
          variant='h6'
          sx={{ fontWeight: 'bold' }}
        >
          {title}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box>
          <Grid
            container
            spacing={2}
            sx={{ marginBottom: 2, display: 'block' }}
          >
            {data.map((item, index) => (
              <Grid
                item
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  {item.display_name}
                </Typography>
                <Typography>{item.label}</Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Paper>
    </>
  );
}

export default OrderSummaryInfo;
